<db-dialog-wrapper [dialog]="this" [hasCloseButton]="true" [canClose]="true"
                   [width]="!!isMobile ? '100%' : '488px'" [fullScreen]="!!isMobile">
  <div class="tags-list-dialog" *ngIf="!loading">
    <h1>{{'text_tags' | dbText}}</h1>
    <div class="tags-list-dialog__tags" dbCustomScrollbar>
      <db-tag-item *ngFor="let tagItem of tagsList | sortBy : 'id' : 'desc'"
                   [addedTag]="addedTag"
                   [domainIds]="domainIds"
                   [tag]="tagItem" (closeDialog)="close()"
                   (checkedTag)="onItemToggled($event)"
      ></db-tag-item>
    </div>

    <div class="tags-list-dialog__buttons">
      <div class="tags-list-dialog__assign-tags" (click)="showAddTagDialog()">
        <i class="db-icon db-icon-add-website"></i>
        <span>{{'text_assignTags' | dbText}}</span>
      </div>
      <a class="ds-btn-blue" (click)="addDomainTag()">
        <span>{{'text_saveTags' | dbText}}</span>
      </a>
    </div>
  </div>
  <db-loading-screen [ngClass]="{'hidden':!loading}"></db-loading-screen>
</db-dialog-wrapper>
